import { GDL_INIT_SUCCESS } from "../constants/app";
import {
  FM_DISABLE_AUTOSAVE,
  FM_ENABLE_AUTOSAVE,
  FM_NEW_CONCEPT_SUCCESS,
  FM_OPEN_REVISION_SUCCESS,
  FM_SAVE_REVISION_SUCCESS
} from "../constants/filemanager";
import { autoSave } from "../actions/filemanager";

const AUTOSAVE_INTERVAL = 60 * 1000; // 60 seconds

let hasGdlSession = false;
let hasWorkingConcept = false;
let isEnabled = true;
let isRunning = false;
let timer;

const start = dispatch => {
  if (isRunning || !isEnabled || !hasGdlSession || !hasWorkingConcept) {
    return false;
  }
  isRunning = true;

  timer = setInterval(function() {
    dispatch(autoSave());
  }, AUTOSAVE_INTERVAL);
};

const stop = () => {
  isRunning = false;
  clearInterval(timer);
};

const autoSaveMiddleware = ({ dispatch, getState }) => next => action => {
  switch (action.type) {
    case GDL_INIT_SUCCESS:
      hasGdlSession = true;
      start(dispatch);
      break;
    case FM_ENABLE_AUTOSAVE:
      isEnabled = true;
      start(dispatch);
      break;
    case FM_DISABLE_AUTOSAVE:
      isEnabled = false;
      stop();
      break;
    case FM_OPEN_REVISION_SUCCESS:
      hasWorkingConcept = true;
      start(dispatch);
      break;
    case FM_SAVE_REVISION_SUCCESS:
      hasWorkingConcept = true;
      start(dispatch);
      break;
    case FM_NEW_CONCEPT_SUCCESS:
      hasWorkingConcept = false;
      stop();
      break;
    default:
      // no-op
      break;
  }

  return next(action);
};

export default autoSaveMiddleware;
